<script>
	import { slide } from 'svelte/transition';
</script>

<div
	transition:slide
	class="full-width bg-indow-green grid w-full place-content-center py-3 text-white"
>
	<a
		href="/window-insert-tax-savings"
		class="text-md m-0 flex w-full items-center justify-center gap-2 p-0 text-center font-medium text-balance text-white no-underline"
	>
		<span>Save up to $1,200 on window inserts</span>
		<div class="h-6 w-6">
			<svg
				width="100%"
				height="100%"
				viewBox="0 0 95 95"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<g>
					<path
						d="M37 1.125C35.5 -0.375 33.0996 -0.375 31.7002 1.125C30.2002 2.625 30.2002 5.02499 31.7002 6.42499C31.7002 6.42499 42.5996 17.325 42.5996 17.325C42.5996 17.325 3.7998 17.325 3.7998 17.325C1.7002 17.325 0 19.025 0 21.125C0 23.225 1.7002 24.925 3.7998 24.925C3.7998 24.925 42.5 24.925 42.5 24.925C42.5 24.925 31.5996 35.725 31.5996 35.725C30.0996 37.225 30.0996 39.625 31.5996 41.025C32.2998 41.725 33.2998 42.125 34.2998 42.125C35.2998 42.125 36.2002 41.725 37 41.025C37 41.025 54.2998 23.725 54.2998 23.725C55 23.025 55.4004 22.025 55.4004 21.025C55.4004 20.025 55 19.025 54.2998 18.325C54.2998 18.325 37 1.125 37 1.125C37 1.125 37 1.125 37 1.125Z"
						fill="#fff"
						transform="translate(20 26)"
					/>
					<path
						d="M47.5 0C21.2998 0 0 21.3 0 47.5C0 73.7 21.2998 95 47.5 95C73.7002 95 95 73.7 95 47.5C95 21.3 73.7002 0 47.5 0C47.5 0 47.5 0 47.5 0ZM47.5 87.5C25.5 87.5 7.5 69.5 7.5 47.5C7.5 25.5 25.5 7.5 47.5 7.5C69.5 7.5 87.5 25.5 87.5 47.5C87.5 69.5 69.5 87.5 47.5 87.5C47.5 87.5 47.5 87.5 47.5 87.5Z"
						fill="#fff"
					/>
				</g>
			</svg>
		</div>
	</a>
</div>
